export default __webpack_public_path__ + "static/resource_card_placeholder-b27801e277cacf1f412677a591d360e0.png";